import {
  MdArrowBack,
  MdDateRange,
  MdEvent,
  MdLocationOn,
} from "react-icons/md";

// Helper function to determine event status based on dates
const statusDate = (start, end) => {
  const now = new Date();
  const startDate = new Date(start);
  const endDate = new Date(end);
  if (now < startDate) return "À venir";
  if (now > endDate) return "Terminé";
  return "En cours";
};

const getStatusColor = (status) => {
  switch (status) {
    case "À venir":
      return "bg-blue-500";
    case "En cours":
      return "bg-green-500";
    case "Terminé":
      return "bg-gray-500";
    default:
      return "bg-[#d4af37]/80";
  }
};

// Composant pour l'affichage des détails d'un événement
const EventDetails = ({ event, onClose, getPhotoUrl }) => {
  const status = statusDate(event.dateDebut, event.dateFin);
  const statusColorClass = getStatusColor(status);

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("fr-FR", options);
  };

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="flex justify-between border-b border-gray-200 pb-4">
        <h2 className="text-2xl font-bold text-gray-800">{event.title}</h2>
        <button
          onClick={onClose}
          className="rounded-md border border-gray-300 px-3 py-1 text-sm transition-colors hover:bg-gray-100"
        >
          <MdArrowBack className="mr-1 inline" /> Retour
        </button>
      </div>

      {/* Image */}
      <div className="relative mb-6 h-64 w-full overflow-hidden rounded-lg">
        {event.photo ? (
          <img
            src={getPhotoUrl(event.photo)}
            alt={event.title}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-[#2ca01c]/10 to-[#7028a9]/10">
            <MdEvent className="text-9xl text-[#2ca01c]/30" />
          </div>
        )}
        <div className="from-black/60 to-transparent absolute bottom-0 left-0 w-full bg-gradient-to-t p-4">
          <span
            className={`rounded-full ${statusColorClass} px-4 py-1 text-sm font-medium text-white`}
          >
            {status}
          </span>
        </div>
      </div>

      {/* Informations de l'événement */}
      <div className="space-y-6">
        {/* Période et lieu */}
        <div className="grid grid-cols-1 gap-4 rounded-lg bg-gray-50 p-4 md:grid-cols-2">
          <div>
            <h3 className="mb-2 flex items-center text-lg font-medium text-gray-700">
              <MdDateRange className="mr-2 text-[#7028a9]" /> Période
            </h3>
            <div className="pl-7 text-gray-600">
              <div>
                <span className="font-medium">Début:</span>{" "}
                {formatDate(event.dateDebut)}
              </div>
              <div>
                <span className="font-medium">Fin:</span>{" "}
                {formatDate(event.dateFin)}
              </div>
            </div>
          </div>
          <div>
            <h3 className="mb-2 flex items-center text-lg font-medium text-gray-700">
              <MdLocationOn className="mr-2 text-[#7028a9]" /> Lieu
            </h3>
            <div className="pl-7 text-gray-600">{event.location}</div>
          </div>
        </div>

        {/* Description */}
        <div className="rounded-lg border border-gray-200 p-4">
          <h3 className="mb-3 text-lg font-medium text-gray-700">
            Description
          </h3>
          <div className="whitespace-pre-line text-gray-600">
            {event.description || "Aucune description fournie."}
          </div>
        </div>

        {/* Métadonnées */}
        <div className="rounded-lg bg-gray-50 p-4 text-sm text-gray-500">
          <div className="flex flex-wrap justify-between gap-4">
            <div>
              <span className="font-medium">ID de l'événement:</span> {event.id}
            </div>
            <div>
              <span className="font-medium">Créé le:</span>{" "}
              {new Date(event.dateDebut).toLocaleDateString()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDetails;
